import React from 'react';

const PubFile = () => (
    <svg viewBox={'0 0 18 18'} xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fillRule="evenodd">
            <path fill="#087366" d="M12.877 2.672v.619l2.807 1.628v6.676h1.753V2.672z" />
            <path
                fill="#087366"
                d="M10.582 5.115V6.18h3.507v2.744h-3.507v.906h3.507v.792h-3.507v1.033h3.507v.792h-3.507v1.033h3.507v.792h-3.507v1.036h4.575V5.115zM.563 2.439V15.56l9.492 1.877V.563z"
            />
            <path
                d="M4.288 9.965v2.49H3.123V5.753h2.564c.749 0 1.343.195 1.783.585.44.39.661.905.661 1.546 0 .657-.216 1.168-.647 1.533-.43.365-1.035.548-1.81.548H4.287zm0-.935h1.399c.414 0 .73-.097.948-.292.218-.195.327-.476.327-.844 0-.363-.11-.652-.332-.868-.22-.216-.524-.328-.91-.334H4.287V9.03z"
                fill="#FFF"
            />
        </g>
    </svg>
);

export default PubFile;
